// What the Connection screen's URL says: which tab is open, and where Close goes.

type ConnectionSubPage = 'configuration' | 'details';

// The router matches /connections/:id/routes/ (trailing slash) too, and a raw
// endsWith test would hand that URL the wrong tab.
const normalizePath = (pathname: string) => pathname.replace(/\/+$/, '') || '/';

// Which tab the URL opens. The Routes tab carries an explicit /routes suffix
// so the bare /connections/:id path is never the only way to reach it.
export const connectionSubPage = (
  pathname: string,
  connectionId: string | undefined,
): ConnectionSubPage => {
  const path = normalizePath(pathname);
  const isConfig = path.endsWith('/configuration');
  // Exactly the bare canonical path opens Configuration: for a non-provider
  // record it is a resting place, and Configuration is what every in-app
  // link opens. Everything else — the /routes suffix and the non-canonical
  // mounts (/sources/destination/:id, /routes/:rid/:subpage/:id) — shows the
  // Routes tables.
  const isBareConnection =
    !!connectionId && path === `/connections/${connectionId}`;
  return isConfig || isBareConnection ? 'configuration' : 'details';
};

// Where Close leads. Canonical routes (/connections/:id[/configuration|/routes])
// always go to the list — going "up" to the bare path instead would re-open
// Configuration (the bare default). Legacy routes (/destination/:id and nested
// /.../destination/:id) go to the page they were opened from. Undefined means
// stay put.
export const closeTarget = (pathname: string): string | undefined => {
  const path = normalizePath(pathname);
  if (path.startsWith('/connections/')) return '/connections';
  const pathArray = path.split('/').filter(Boolean);
  const destinationIndex = pathArray.indexOf('destination');
  if (destinationIndex > -1) {
    const newPathArray = pathArray.slice(0, destinationIndex);
    return `/${newPathArray.join('/')}` || '/';
  }
  return undefined;
};
